import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type Operator = {
  username: string;
  display_name: string | null;
  email: string | null;
  role: "admin" | "operator" | "viewer";
  active: boolean;
  last_login_at: string | null;
};

type State = {
  access: string | null;
  refresh: string | null;
  user: Operator | null;
  setSession: (s: { access: string; refresh: string; user: Operator }) => void;
  logout: () => void;
};

export const useAuth = create<State>()(
  persist(
    (set) => ({
      access: null,
      refresh: null,
      user: null,
      setSession: ({ access, refresh, user }) => set({ access, refresh, user }),
      logout: () => set({ access: null, refresh: null, user: null }),
    }),
    {
      name: "tcg-inv-hub-auth",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
